RivalIQ.module('errors.script', function (module, App, Backbone, Marionette, $, _, window) {

    'use strict';

    // NOTE exposed for testing
    module.getRollbar = function () {
        return window.Rollbar;
    };

    module.reportError = function (message, error) {
        const Rollbar = module.getRollbar();
        if (Rollbar) {
            Rollbar.error(message, error);
        } else {
            RivalIQ.logger.error(`${message} ${error}`);
        }
    };

    window.onerror = module.onWindowErrorHandler = function (message, url, line, column, error) {
        const Rollbar = module.getRollbar();
        // NOTE the second test case for each line is for the marketing site
        const id = (RivalIQ.state.user.get('id') || _.get(window, 'rivalIqSettings.userId'));
        const email = (RivalIQ.state.user.get('email') || _.get(window, 'rivalIqSettings.email'));

        // IMPORTANT DO NOT REMOVE
        // phantom needs us to explicitly log the error or its onError hook
        // will not be called
        // TODO check if this is still needed in the puppeteer world
        RivalIQ.logger.error(message);

        if (Rollbar) {
            if (id || email) {
                Rollbar.configure({
                    payload: {
                        person: {
                            id: id,
                            email: email,
                            headless: (RivalIQ.isHeadless ? 'HEADLESS' : 'NOT_HEADLESS'),
                            viewState: RivalIQ.state.view.toJSON()
                        }
                    }
                });
            }

            Rollbar.handleUncaughtException(message, url, line, column, error);
        }

        return false;
    };

}, window);
